import { Button, LoginContext } from '@2r/frontend-component-library';
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom';

export function Logout() {
    const navigate = useNavigate();
    const ctx = useContext<LoginContext>(LoginContext);

    function logout() {
        ctx.setToken('');
        ctx.onLogout();
        navigate('/login');
    }

    return <Button Name="Logout" Label="Abmelden" onClick={() => logout()} />;
}